import {
    API_URL
} from "../../utils/constant";
import {
    toastr
} from "react-redux-toastr";
import axios from "axios";

var Actions = {
    takeDown: (props) => {
        return new Promise((resolve, reject) => {
            const session = localStorage.getItem("session");
            axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    
            axios
             .post(`${API_URL}/takeDown`, { ...props })
                .then((response) => {
                    if (response.status !== 200) {
                        toastr.error("Error", "Some server error has occurred.")
                    } else {
                        toastr.success("Success", "Takedown request submitted")
                        resolve(response.data);
                    }
                })
                .catch((err) => {
                    let message = "Some server error has occurred.";
                    if (err.response) {
                        message = err.response.data.userMessage;
                        toastr.error("Error", message);
                    }
                    reject(err);
                });
        });
    }
}

export default Actions;